import { get, post } from "./request";
import request from "./request";

/**
 * API Keys 接口（API 文档第 9 节 /console/api-keys）。
 */

// ---------- 类型 ----------

export interface ApiKey {
  id: number;
  name: string;
  /** 后端返回的已脱敏 key，如 "csgw_-n****" */
  key: string;
  status: string;
  lastUsedAt: string | null;
  createdAt: string;
}

/** POST /api-keys 的返回：token 为一次性明文 key */
export interface CreateApiKeyResult {
  name: string;
  token: string;
  appKey: string;
  message: string;
}

// ---------- 接口 ----------

export function getApiKeys(): Promise<ApiKey[]> {
  return get<ApiKey[]>("/api-keys");
}

export function createApiKey(name: string): Promise<CreateApiKeyResult> {
  return post<CreateApiKeyResult>("/api-keys", { name });
}

export function deleteApiKey(id: number): Promise<{ message: string }> {
  return request.delete(`/api-keys/${id}`) as unknown as Promise<{
    message: string;
  }>;
}
